<div class="token-content bpx-dialog">
    <h2 mat-dialog-title> Token is Expired </h2>
    <p class="token-content__message" i18n>Re-authorize to continue your session.</p>
    <button matRipple class="bpx-btn bpx-btn--primary" type="submit"
            [disabled]="isAuthorizing"
            (click)="login()">
      <div>{{ isAuthorizing ? 'Re-Authorizing…' : 'Re-Authorize Token' }}</div>
    </button>
    @if (errorMessage) {
      <p class="token-content__error" role="alert">{{ errorMessage }}</p>
    }
  </div>
